import React from "react";
import {
  omitThemingProps,
  Checkbox,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import propTypes from "prop-types";
import { useMultiSelect } from "./MultiSelectContext";

const checkboxStyles = {
  backgroundColor: "white",
  display: "flex",
  marginTop: "0 !important",
  padding: "2",
  width: "100%",
  _checked: {
    backgroundColor: "gray.200",
  },
};

const MultiSelectOption = (props) => {
  // Get theme styles
  const { multiSelectOption } = useMultiStyleConfig("MultiSelect", props);

  // Destructure props and exclude theme props
  const { children, ...rest } = omitThemingProps(props);

  // Utility Hooks
  const { disabled, filter, id, name, onChange, readOnly, value } =
    useMultiSelect();
  const isActive = value?.findIndex((v) => v.value === rest.value) > -1;

  // Event Listeners
  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      onChange([...value, { label: children, value: rest.value }], event);
    } else {
      onChange(
        value?.filter((v) => v.value !== rest.value),
        event
      );
    }
  };

  const compareValue =
    typeof children === "string" ? children.toLowerCase() : "";

  const shouldShow =
    filter.length <= 0 ||
    (filter.length > 0 && compareValue.includes(filter.toLowerCase()));

  if (shouldShow) {
    return (
      <Checkbox
        __css={checkboxStyles}
        isChecked={isActive}
        disabled={disabled}
        id={`${id}-${rest.value}`}
        name={name}
        onChange={handleCheckboxChange}
        readOnly={readOnly}
        required={false}
        sx={multiSelectOption}
        {...rest}
      >
        {children}
      </Checkbox>
    );
  } else {
    return null;
  }
};

MultiSelectOption.propTypes = {
  children: propTypes.node,
  value: propTypes.string,
};

export default MultiSelectOption;
